import { useForm } from "react-hook-form";
import { CityPayloadSchema, cityPayloadSchema, useCity } from "@/api/city";
import { zodResolver } from "@hookform/resolvers/zod";
import { Loading } from "@/components/ui/loading";
import { CityFormFields } from "./CityFormFields";
import { FormContainer } from "@/components/form/form-container";
import { Anchor } from "@/components/ui/anchor";

export function CityDetailForm({ id }: { id: string }) {
  const {
    data: city,
    isPending: isLoadingData,
    isError,
  } = useCity({
    id,
  });
  const form = useForm<CityPayloadSchema>({
    resolver: zodResolver(cityPayloadSchema),
    defaultValues: {
      cityCode: city?.cityCode,
      cityName: city?.cityName,
      province: city?.province,
      ftax: city?.ftax,
      fdtAreaHpm: city?.fdtAreaHpm,
      fibernodeAreaHpm: city?.fibernodeAreaHpm,
      branchHpm: city?.branchHpm,
    },
    values: city,
  });

  if (isLoadingData) {
    return <Loading />;
  }

  if (!city) {
    return <div>City not found</div>;
  }

  if (isError) {
    return <div>Failed to load city</div>;
  }

  return (
    <FormContainer form={form}>
      <CityFormFields isDisabled />
      <div className="ml-auto">
        <Anchor href="/master-data/city" mood="axiata-blue">
          Back
        </Anchor>
      </div>
    </FormContainer>
  );
}
